import { NoSsr } from '@cian/react-utils';
import { LinkButton, UIHeading2, UIText2 } from '@cian/ui-kit';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './AboutCompany.css';
import { DescriptionRow } from './DescriptionRow';
import { PROFILE_URL } from '../../constants/links';
import { IAgentCard } from '../../types/agentCard';
import { Avatar } from '../Avatar';
import { DocumentProof } from '../DocumentProof';
import { KokonCertificate } from '../KokonCertificate';
import { RgrCertificate } from '../RgrCertificate';

interface IAboutBlock {
  label: string;
  text: string;
  action?(): void;
}
export interface IAboutCompanyProps {
  descriptionList: IAboutBlock[];
  avatarUrl: IAgentCard['avatarUrl'];
  name: IAgentCard['name'];
  superAgent: React.ReactNode | null;
  experience: string;
  age: string;
  showProfileLinkButton: boolean;
  isUserIdentifiedByDocuments: boolean;
  hasRgrParticipation: boolean;
  hasKokonParticipation: boolean;
}

export const AboutCompany = ({
  descriptionList,
  avatarUrl,
  name,
  superAgent,
  experience,
  age,
  showProfileLinkButton,
  isUserIdentifiedByDocuments,
  hasRgrParticipation,
  hasKokonParticipation,
}: IAboutCompanyProps) => {
  return (
    <div className={styles['container']}>
      <div className={cx(styles['column'], styles['column-avatar'])} data-name="CompanyAvatar">
        <NoSsr>
          <Avatar avatarUrl={avatarUrl} />
        </NoSsr>
        {age && <UIText2 data-name="CompanyAge">{age}</UIText2>}
      </div>
      <div className={cx(styles['column'], styles['column-info'])}>
        <div className={styles['row-name']}>
          <UIHeading2 data-name="CompanyName">{name}</UIHeading2>
          {showProfileLinkButton && (
            <LinkButton target="_blank" size="XS" theme="fill_secondary" href={PROFILE_URL}>
              Редактировать
            </LinkButton>
          )}
        </div>
        <div className={styles['badges']}>
          {superAgent}
          {hasRgrParticipation && <RgrCertificate />}
          {hasKokonParticipation && <KokonCertificate />}
        </div>
        {isUserIdentifiedByDocuments && <DocumentProof text="Документы проверены" />}
        {experience && <UIText2 data-name="CompanyExperience">{experience}</UIText2>}
        <div className={styles['description-container']} data-name="CompanyDescription">
          {descriptionList.map(({ label, text, action }) => (
            <DescriptionRow key={label} label={label} text={text} action={action} />
          ))}
        </div>
      </div>
    </div>
  );
};
